import {html, type TemplateResult} from "lit";
import {customElement, property, state} from "lit/decorators.js";
import type {DirectiveResult} from "lit/directive.js";
import {templateContent} from "lit/directives/template-content.js";
import type {Nullable} from "../../bootstrap/common/types";
import {classMap} from "lit/directives/class-map.js";
import {UnLitElement} from "../../common/elements";

@customElement("eop-macherbus-ranked-project")
export class EopMacherbusRankedProject extends UnLitElement {

    @property({attribute: "content"})
    public contentId: string;
    @property({attribute: "project-id"})
    public projectId: string;
    @property({attribute: "image-src"})
    public imageSrc: string;
    @property({attribute: "image-alt"})
    public imageAlt: string;
    @property({state: true})
    public rank: number;
    @state()
    private votesCast: Nullable<number> = null;

    private textualContent: DirectiveResult;

    public connectedCallback(): void {
        super.connectedCallback();

        const textualContentTemplate = this.resolveTemplateElement(this.contentId);
        if (textualContentTemplate !== null) {
            this.textualContent = templateContent(textualContentTemplate);
        }
    }

    public render(): TemplateResult {
        const rankClass = {
            "top-rank": this.rank <= 3,
            "bottom-rank": this.rank > 3
        };
        return html`
            <div class="project-tile">
                <div class="tile-image">
                    <eop-responsive-image
                            image-src=${this.imageSrc}
                            image-alt=${this.imageAlt}
                            max-crop-threshold="0.25"
                    ></eop-responsive-image>
                    <div class="rank-badge ${classMap(rankClass)}">
                        <div class="rank-label"><eop-msg key="RANK_NUMBER_LABEL"></eop-msg></div>
                        <div class="rank-number">${this.rank}</div>
                    </div>
                    ${this.renderVotesCast()}
                </div>
                <div class="tile-non-image">
                    <div class="tile-text reverse-background">
                        ${this.textualContent}
                    </div>
                </div>
            </div>
        `;
    }

    private renderVotesCast(): Nullable<TemplateResult> {
        if (this.votesCast === null) {
            return null;
        }

        return html`
            <div class="votes">${this.votesCast} <eop-msg key="VOTES_CAST_LABEL"></eop-msg></div>
        `;
    }

    public setRanking(rank: number, votesCast: Nullable<number>): void {
        this.rank = rank;
        this.votesCast = votesCast;
    }

    public compareTo(other: EopMacherbusRankedProject): number {
        return this.rank - other.rank;
    }
}